<template>
  <div class="components-container">
    <header>
      <span class="title">收费策略</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(24)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @selection-change='handleSelectionChange' @row-click="rowClick">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='sort' label='版本序号' min-width='90'></el-table-column>
      <el-table-column prop='version_name' label='版本名称' min-width='160'></el-table-column>
      <el-table-column prop='unit_price' label='单价' min-width='120'></el-table-column>
      <el-table-column label='状态' min-width='100'>
        <template slot-scope='scope'>{{ scope.row.status == 0 ? '启用' : '禁用'}}</template>
      </el-table-column>
      <el-table-column prop='user_count' label='适用人数' min-width='120'></el-table-column>
      <el-table-column prop='usersnumber' label='已使用客户数' min-width='120'></el-table-column>
      <el-table-column prop='description' label='版本说明' :show-overflow-tooltip="true" min-width='160'></el-table-column>
      <el-table-column prop='create_by' label='创建人' min-width='140'></el-table-column>
      <el-table-column label='创建时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n2" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogDetail">
        <header>
          <img src="/static/images/icon-company.png">
          {{strategyDetail.version_name}}
          <i class="iconfont icon-close" @click="dialogDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>基本资料</span></div>
          <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>功能清单</span></div>
          <div class="tab-item" :class="(tabType == 2)?'active':''" @click="dtlChange(2)" v-if="moduleIds.includes(1) || moduleIds.includes(2)"><span>客户</span></div>
          <div class="tab-item" :class="(tabType == 3)?'active':''" @click="dtlChange(3)"><span>操作记录</span></div>
        </div>
        <div class="head" v-if="tabType == 0">
          <span>基本资料</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="strategyDetail.usersnumber == 0 && (funAuth.includes(26) || funAuth.includes(27))">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" v-if="strategyDetail.status == 1 && funAuth.includes(26)">启  用</el-dropdown-item>
              <el-dropdown-item command="1" v-if="strategyDetail.status == 0 && funAuth.includes(26)">停  用</el-dropdown-item>
              <el-dropdown-item command="2" v-if="funAuth.includes(27)">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editDialog" v-if="funAuth.includes(25)">编 辑</el-button>
        </div>
        <div class="head" v-if="tabType == 1">
          <span>功能清单</span>
          <el-button type="primary" @click="editFeature" v-if="funAuth.includes(25)">编 辑</el-button>
        </div>
        <div class="head" v-if="tabType == 2">
          <span>客户</span>
        </div>
        <div class="head" v-if="tabType == 3">
          <span>操作记录</span>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames" v-if="tabType == 0">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">版本名称</span>
                  <div class="item-content">{{strategyDetail.version_name}}</div>
                </div>
                <div class="item">
                  <span class="title">客户状态</span>
                  <div class="item-content">{{(strategyDetail.status == 0 ? '启用':'停用')}}</div>
                </div>
                <div class="item">
                  <span class="title">使用客户数</span>
                  <div class="item-content">{{strategyDetail.usersnumber}}</div>
                </div>

                <div class="item">
                  <span class="title">版本序号</span>
                  <div class="item-content">{{strategyDetail.sort}}</div>
                </div>
                <div class="item">
                  <span class="title">版本单价</span>
                  <div class="item-content">{{strategyDetail.unit_price}}</div>
                </div>
                <div class="item">
                  <span class="title">适用人数</span>
                  <div class="item-content">{{strategyDetail.user_count}}</div>
                </div>
                <div class="item">
                  <span class="title">版本说明</span>
                  <div class="item-content">{{strategyDetail.description}}</div>
                </div>

                <div class="item single">
                  <span class="title">备注</span>
                  <div class="item-content">{{strategyDetail.remark}}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{strategyDetail.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{strategyDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item">
                  <span class="title">修改人</span>
                  <div class="item-content">{{strategyDetail.modify_by}}</div>
                </div>
                <div class="item">
                  <span class="title">修改时间</span>
                  <div class="item-content">{{strategyDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <feature-list v-if="tabType == 1 && featureData.data" :featureData="featureData"></feature-list>
          <el-table v-if="tabType == 2" class="el-table-01" :data='userData' style='width: 100%' @row-click="userClick">
            <el-table-column prop='company_no' label='公司编号' min-width='160'></el-table-column>
            <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
            <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
            <el-table-column prop='phone' label='联系电话' min-width='140' :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label='账号状态' min-width='100'>
              <template slot-scope='scope'>{{ scope.row.status == 0 ? '启用' : '禁用'}}</template>
            </el-table-column>
            <el-table-column label='开通版本' min-width='140'>
              <template slot-scope='scope'>
                <span v-text="editionInit(scope.row.edition)"></span>
              </template>
            </el-table-column>
            <el-table-column prop='allow_number' label='开通坐席' min-width='100'></el-table-column>
            <el-table-column label='套餐开始时间' min-width='140'>
              <template slot-scope='scope'>{{ scope.row.start_time | formatDate('yyyy-MM-dd') }}</template>
            </el-table-column>
            <el-table-column label='套餐结束始时间' min-width='140'>
              <template slot-scope='scope'>{{ scope.row.end_time | formatDate('yyyy-MM-dd') }}</template>
            </el-table-column>
            <el-table-column label='附件空间' min-width='100'>
              <template slot-scope='scope'>{{scope.row.attachment_size}}GB</template>
            </el-table-column>
            <el-table-column prop='data_size' label='总数据量' min-width='100'>
              <template slot-scope='scope'>{{scope.row.data_size}}条</template>
            </el-table-column>
            <el-table-column prop='invite_code' label='邀请码' min-width='100'></el-table-column>
            <el-table-column prop='customer_name' label='维护客服' min-width='100'></el-table-column>
            <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
            <el-table-column label='创建时间' min-width='180'>
              <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
            </el-table-column>
          </el-table>
          <el-pagination v-if="tabType == 2" @size-change='handleSizeChange2' @current-change='handleCurrentChange2' :current-page='pageNum2' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize2' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal2'></el-pagination>
          <div class="log-box" v-if="tabType == 3">
            <div class="log-item" v-for="(date, index) in logList" :key="index">
              <div class="line">
                <div class="circle"></div>
              </div>
              <div class="rihgt">
                <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                <div class="content">{{date.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
    </transition>

    <div class="mask n1" v-if="dialogHandle" @click="dialogHandle = false"></div>
    <transition name="slide">
      <el-container class="add-dialog additional-handle-dialog" v-if="dialogHandle">
        <header>
          <span>收费策略</span>
          <i class="iconfont icon-close" @click="dialogHandle = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">收费策略</div>
            <div class="h2">自由灵活搭配软件版本，满足客户个性需求。</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>版本名称</span>
                <div class="item-right">
                  <el-input v-model="version_name" placeholder="请输入(必填)" size="medium" maxlength="25"></el-input>
                </div>
                <div class="err" v-if="err_vn"><i class="el-icon-warning"></i>{{err_vn}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>状态</span>
                <div class="item-right">
                  <el-select v-model="status" placeholder="请选择(必填)" :disabled="!!dialogDetail">
                    <el-option label="启用" value="0"></el-option>
                    <el-option label="禁用" value="1"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err_s"><i class="el-icon-warning"></i>{{err_s}}</div>
              </div>

              <div class="form-item">
                <span class="item-title">版本序号</span>
                <div class="item-right">
                  <el-input type="number" v-model="sort" placeholder="请输入(必填)" size="medium" maxlength="10"></el-input>
                </div>
                <div class="err" v-if="err_sort"><i class="el-icon-warning"></i>{{err_sort}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>版本单价</span>
                <div class="item-right">
                  <el-input type="number" v-model="unit_price" placeholder="请输入(必填)" size="medium" maxlength="10"></el-input>
                </div>
                <div class="err" v-if="err_up"><i class="el-icon-warning"></i>{{err_up}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>适用人数</span>
                <div class="item-right">
                  <el-input type="number" v-model="user_count" placeholder="请输入(必填)" size="medium" maxlength="10"></el-input>
                </div>
                <div class="err" v-if="err_uc"><i class="el-icon-warning"></i>{{err_uc}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>版本说明</span>
                <div class="item-right">
                  <el-input v-model="description" placeholder="请输入(必填)" size="medium" maxlength="12"></el-input>
                </div>
                <div class="err" v-if="err_desc"><i class="el-icon-warning"></i>{{err_desc}}</div>
              </div>

              <div class="form-item single">
                <span class="item-title">备注</span>
                <div class="item-right">
                  <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
                </div>
              </div>
            </div>

            <div class="func" v-if="!dialogDetail">
              <div class="head">功能</div>
              <feature-list :featureData="featureData"></feature-list>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogHandle = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>

    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(strategyDetail.status == 0) ? '停用':'启用'}}</div>
      <div class="note">{{(strategyDetail.status == 0) ? '当前版本下无使用客户，确定要停用该版本吗？':''}}</div>
      <div class="prompt">{{(strategyDetail.status == 0) ? '确定要重新停用该版本吗？':'确定要重新启用该版本吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="strategyStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后不可恢复。</div>
      <div class="prompt">你确定要删除该版本吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="strategyDelete">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n1" v-if="dialogfeature" @click="dialogfeature = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip feature-detail-wrip" v-if="dialogfeature">
        <header>
          <span>编辑功能</span>
          <i class="iconfont icon-close" @click="dialogfeature = false"></i>
        </header>
        <div class="notice">此功能只是为了纠正重大误操作，用户一旦在前台使用该功能又遇到后台减少时，可能会导致数据丢失，所以请谨慎使用，切不可滥用。</div>
        <feature-list :featureData="{data: featureData.data, type: 2}"></feature-list>
        <footer>
          <el-button @click="dialogfeature = false">取 消</el-button>
          <el-button type="primary" @click="savefeature">保 存</el-button>
        </footer>
      </el-container>
    </transition>

    <div class="mask n2" v-if="dialogCusDetail" @click="dialogCusDetail = false"></div>
    <transition name="slide">
      <!-- belong_type 0：注册用户 1：试用客户 2 正式客户 -->
      <trial-detail v-if="dialogCusDetail && customerData.belong_type == 1" :customer="customerData"></trial-detail>
      <customer-detail v-if="dialogCusDetail && customerData.belong_type == 2" :customer="customerData"></customer-detail>
    </transition>
  </div>
</template>
<script>
import mixin from '@/common/js/mixins.js'
import strategyJS from '@/controller/strategy.js'
import featureList from '@/common/components/feature-list'// 功能清单
import customerDetail from '@/common/components/customer-detail'// 详情
import trialDetail from '@/common/components/trial-detail'// 试用客户详情
export default {
  data () {
    return {
    }
  },
  mixins: [strategyJS, mixin],
  components: {
    featureList,
    customerDetail,
    trialDetail
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/strategy.vue